<template>
  <div class="cart-container">
    <div class="cart-icon-wrapper">
      <i class="fa fa-basket-shopping"></i>
      <span class="cart-count">{{ itemCount }}</span>
    </div>
    <div class="cart-label">Carrinho</div>
  </div>
</template>

<script setup>
import { useCartStore } from '@/stores/cartStore'
import { computed } from 'vue'

// 📌 Recebe o ID do evento como prop
const props = defineProps({
  eventId: {
    type: String,
    required: true
  }
})

const cart = useCartStore()

const itemCount = computed(() => {  
  const event = cart.getEvent(props.eventId)
  return event ? event.items.reduce((sum, item) => sum + item.quantity, 0) : 0
})
</script>


<style scoped>
.cart-container {
  width: 79px;
  border: 2px dashed color-mix(in srgb, var(--event-primary, #f78da7) 40%, #d0d0d0);
  padding: 18px 0px 10px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 35px;
  transition: border 0.3s ease;
  cursor: pointer;
}

.cart-container:hover {
  border-color: var(--event-primary, #f78da7);
}

.cart-icon-wrapper {
  position: relative;
  font-size: 26px;
  color: #42477e;
}

.cart-count {
  position: absolute;
  top: -8px;
  right: -12px;
  background: var(--event-primary, #f78da7);
  color: white;
  font-size: 12px;
  border-radius: 100%;
  padding: 1px 7px;
}

.cart-label {
  font-size: 14px;
  color: #32355d;
  font-weight: bold;
}
</style>
